export default __webpack_public_path__ + "static/media/Typology1.a4210ab9.png";